export interface Toast {
    id: number;
    type: 'success' | 'error' | 'info';
    message: string;
}

class ToastStore {
    items = $state<Toast[]>([]);
    private nextId = 1;

    push(type: Toast['type'], message: string, ttl = 4000) {
        const id = this.nextId++;
        this.items.push({ id, type, message });
        setTimeout(() => this.dismiss(id), ttl);
    }

    success(msg: string) { this.push('success', msg); }
    error(msg: string)   { this.push('error', msg, 6000); }
    info(msg: string)    { this.push('info', msg); }

    dismiss(id: number) {
        this.items = this.items.filter((t) => t.id !== id);
    }
}

export const toast = new ToastStore();